var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sn-page sn-assembly sn-f-c-c loading-page"},[_c('div',{staticClass:"loading-blank"})])}]

export { render, staticRenderFns }